import { List } from '@mui/material';
import React, { useMemo, useState, useEffect } from 'react'
import { getVariantText } from '../../../../../../utils/helper';
import { useSelector } from 'react-redux';
import RenderNodeValues from './RenderNodeValues';
import {
  getFilteredProperties,
  resolveSubAssetTypes,
} from './buildingProfileFieldFilters';

const RenderProperty = ({properties, onListUpdate}) => {
    const [propertyList, setPropertyList] = useState(properties);
    const scope = useSelector((state) => state.container.scope);
    const openAsset = useSelector((state) => state.openAsset);

    useEffect(() => {
      const subAssetTypes = resolveSubAssetTypes({ properties });
      setPropertyList(getFilteredProperties(properties, subAssetTypes));
    }, [properties, openAsset?.ident]);

    const updatePropertyList = (item, nodeValues) => {
      let temp = [...propertyList];
      const index = temp.findIndex((t) => t.nodeIdent === item.nodeIdent);
      if(index !== -1) {
        temp[index] = {...temp[index], nodeValue: nodeValues, isUpdated: true};
      }
      setPropertyList(temp);
      onListUpdate(temp);
    }

    const sortedItemList = useMemo(() => {
      // Use original order from database for all properties
      return propertyList.toSorted((a, b) => (a.nodeOrder || a.order || 999) - (b.nodeOrder || b.order || 999));
    }, [propertyList, properties]);

    const getPropertyName = (property) => {
        const inputObj = property?.labelTranslation.find(
          (e) => e.language === scope.projectLanguageCode
        );
        return getVariantText(inputObj.title || property?.name, "body1", {
          fontWeight: "bold",
          color: "#254a9a",
          margin: 5,
          textTransform: "uppercase",
        });
      };

  return (
    <>
       {sortedItemList.map((item, index) => {
              return (
                <tr
                  key={item.nodeIdent}
                  id={item.nodeIdent}
                >
                  <td
                    id={`text-${item.nodeIdent}`}
                    style={{
                      wordWrap: "break-word",
                      width: "25%",
                      fontSize: "12px",
                      verticalAlign: "baseline",
                    }}
                  >
                    <div className="sticky-text p-1"
                    >
                    {getPropertyName(item)}
                    </div>
                  </td>
                  <td style={{ width: "75%" }}>
                    <List className={"w-100 p-0"}>
                      <RenderNodeValues item={item} 
                      onUpdate={(item, nodeValue) =>{
                        updatePropertyList(item, nodeValue)
                      }}/>
                    </List>
                  </td>
                </tr>
              );
            })}
            </>
  )
}

export default RenderProperty
